export default "e371fc602c34199f.svg"